import { AxiosInstance, AxiosResponse } from "axios"

export interface AffirmVisibilityResponse extends AxiosResponse {
  data: {
    isAffirmEnabled: string
    isApplePayEnabled: string
    isGooglePayEnabled: string
  }
}

export function affirmVisibilityApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    url: "/booking/affirmflag",
  }) as Promise<AffirmVisibilityResponse>
}
